import React from 'react';
import PropTypes from 'prop-types';

const GoogleMapLink = ({ q, children, disabled = false }) => {
  const encodedQuery = encodeURIComponent(q);

  return (
    <a
      href={disabled ? '#' : `https://www.google.com/maps/place/${encodedQuery}`}
      target="_blank"
      rel="noopener noreferrer"
      className={disabled ? 'no-pointer-events' : ''}
    >
      {children}
    </a>
  );
};

GoogleMapLink.propTypes = {
  q:        PropTypes.string.isRequired,
  children: PropTypes.node.isRequired,
  disabled: PropTypes.bool,
};

export default GoogleMapLink;
